import React from "react";
import useReportFormat from "../useReportFormat";

const CashFlowSection = ({
  paid = 0,
  committed = 0,
  total = 0,
}) => {
  const formatCurrency = useReportFormat();
  const remaining = total - paid - committed;
  const paidPct = total > 0 ? (paid / total) * 100 : 0;
  const committedPct = total > 0 ? (committed / total) * 100 : 0;
  const remainingPct = total > 0 ? (remaining / total) * 100 : 0;

  return (
    <div
      style={{
        background: "white",
        borderRadius: 16,
        padding: 32,
        border: "1px solid #f0f4ff",
        boxShadow: "0 4px 20px -4px rgba(0,0,0,0.05)",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          flexWrap: "wrap",
          gap: 12,
          marginBottom: 24,
        }}
      >
        <div>
          <p
            style={{
              fontWeight: 700,
              fontSize: "1rem",
              color: "#002045",
              margin: 0,
              marginBottom: 2,
            }}
          >
            Budget Breakdown
          </p>
          <p
            style={{
              fontSize: "0.78rem",
              color: "#64748b",
              margin: 0,
              fontWeight: 500,
            }}
          >
            Spend vs committed vs remaining budget
          </p>
        </div>
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            background: "#f8fafc",
            border: "1px solid #e2e8f0",
            borderRadius: 6,
            padding: "6px 12px",
          }}
        >
          <i
            className="ri-calendar-line"
            style={{ color: "#64748b", fontSize: "0.85rem" }}
          />
          <span
            style={{
              fontSize: "0.78rem",
              fontWeight: 600,
              color: "#64748b",
            }}
          >
            Cost Burn Rate
          </span>
        </div>
      </div>

      {/* Multi-segment bar */}
      <div
        style={{
          height: 40,
          borderRadius: 8,
          overflow: "hidden",
          display: "flex",
          marginBottom: 20,
          background: "#e2e8f0",
        }}
      >
        {/* Paid */}
        <div
          style={{
            width: `${paidPct}%`,
            background: "#002045",
            transition: "width 0.5s ease",
            flexShrink: 0,
          }}
        />
        {/* Committed */}
        <div
          style={{
            width: `${committedPct}%`,
            background: "rgba(0,32,69,0.35)",
            transition: "width 0.5s ease",
            flexShrink: 0,
          }}
        />
        {/* Remaining takes rest via flex */}
      </div>

      {/* Segment details */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: 16,
        }}
      >
        {/* Paid */}
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }}>
            <div
              style={{
                width: 10,
                height: 10,
                borderRadius: 2,
                background: "#002045",
                flexShrink: 0,
              }}
            />
            <span
              style={{
                fontSize: "0.7rem",
                fontWeight: 700,
                textTransform: "uppercase",
                letterSpacing: "0.08em",
                color: "#64748b",
              }}
            >
              Paid
            </span>
          </div>
          <div
            style={{
              fontSize: "1.1rem",
              fontWeight: 800,
              color: "#002045",
              marginBottom: 2,
            }}
          >
            {formatCurrency(paid)}
          </div>
          <div style={{ fontSize: "0.75rem", color: "#64748b", fontWeight: 500 }}>
            {paidPct.toFixed(1)}% of total
          </div>
        </div>

        {/* Committed */}
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }}>
            <div
              style={{
                width: 10,
                height: 10,
                borderRadius: 2,
                background: "rgba(0,32,69,0.35)",
                flexShrink: 0,
              }}
            />
            <span
              style={{
                fontSize: "0.7rem",
                fontWeight: 700,
                textTransform: "uppercase",
                letterSpacing: "0.08em",
                color: "#64748b",
              }}
            >
              Committed
            </span>
          </div>
          <div
            style={{
              fontSize: "1.1rem",
              fontWeight: 800,
              color: "#002045",
              marginBottom: 2,
            }}
          >
            {formatCurrency(committed)}
          </div>
          <div style={{ fontSize: "0.75rem", color: "#64748b", fontWeight: 500 }}>
            {committedPct.toFixed(1)}% of total
          </div>
        </div>

        {/* Remaining */}
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }}>
            <div
              style={{
                width: 10,
                height: 10,
                borderRadius: 2,
                background: "#e2e8f0",
                border: "1px solid #cbd5e1",
                flexShrink: 0,
              }}
            />
            <span
              style={{
                fontSize: "0.7rem",
                fontWeight: 700,
                textTransform: "uppercase",
                letterSpacing: "0.08em",
                color: "#64748b",
              }}
            >
              Remaining
            </span>
          </div>
          <div
            style={{
              fontSize: "1.1rem",
              fontWeight: 800,
              color: "#64748b",
              marginBottom: 2,
            }}
          >
            {formatCurrency(remaining)}
          </div>
          <div style={{ fontSize: "0.75rem", color: "#64748b", fontWeight: 500 }}>
            {remainingPct.toFixed(1)}% of total
          </div>
        </div>
      </div>
    </div>
  );
};

export default CashFlowSection;
